module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['draw-whale', {
      'fixed-center': _vm.center,
      active: _vm.loading
    }]
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47a8e46c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimationLoadingWhale.vue
// module id = 2522
// module chunks = 115